import { createApp } from 'vue';
import App from './App.vue';
import InfoBox from './components/InfoBox.vue';
import tealiumHelper from './utils/tealiumHelper';
import '@smartdesign/core/css/main.css';
import '@smartdesign/core/css/themes/iw/index.css';

require('./scss/_app.scss');
require('./scss/_sd-textfield.scss');
require('./scss/_sd-button.scss');
require('./scss/_sd-popover.scss');
require('./scss/_sd-link.scss');
require('./scss/_with-flexbox-separator.scss');

const track = (event: string) => {
  if (event === 'cta-click') {
    tealiumHelper.link({
      event_category: 'button-intern',
      event_action: 'click',
      event_label: 'sla_seller_estimation',
    });
  } else if (event === 'floating-click') {
    tealiumHelper.link({
      event_category: 'button-intern',
      event_action: 'click',
      event_label: 'floating_seller_estimation',
    });
  }
};

// @TODO: This block can be deleted when traffic to the "/anbieten/immobilienbewertung/lp/wlef/" URL decreases.
if (window.location.pathname.startsWith('/anbieten/immobilienbewertung/lp/wlef/')) {
  const newPath = window.location.pathname.replace('/anbieten/immobilienbewertung/lp/wlef/', '/anbieten/immobilienbewertung/lp/');
  window.location.href = `${window.location.origin}${newPath}`;
} else {
  // Vue.js application initialization ↓
  const app = createApp(App);
  app.component('InfoBox', InfoBox);
  app.config.unwrapInjectedRef = true;
  app.config.globalProperties.$env = process.env;
  app.config.globalProperties.track = track;
  app.mount('#app');
  // ↑
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties  {
    track: (_: string) => void
  }
}
